import { IonContent, IonPage, IonItem } from '@ionic/react';
import React, { useContext } from 'react';
import { FiscalizacionContext, IFLP } from './FiscalizacionContext';
import { useParams } from 'react-router';
import Header from '../Header';
import PanelFiscalizacion from './PanelFiscalizacion';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { makeStyles } from '@material-ui/core/styles';

interface Params {
  fis_id: string;
  nombre: string;
  codigo: string;
  objetivo: string;
  ps_id: string;
}

export interface ResumenFiscalizacion {
  readonly name?: string;
  readonly img?: string;
  readonly operario?: Operario[];
}

export interface Operario {
  readonly nombreOperario?: string;
  fiscalizacion?: Fiscalizacion[] | undefined;
}

export interface Fiscalizacion {
  imagen?: string;
  rutinas?: string;
  procedimiento?: string;
}

export interface IResumenDeposito {
  readonly name?: string;
  readonly img?: string;
  calificacion_id: string; // Cambiar el tipo a string para mostrar los valores de calificación
}

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

function fiscalizacionPersonal(name: string, img: string, info?: any): ResumenFiscalizacion {

  const infoArray = Array.isArray(info) ? info : [info];

  const operariosMap: { [key: string]: Operario } = {};

  const calificacionValor = (calificacionID: number) => {
    switch (calificacionID) {
      case 1:
        return 'Excelente';
      case 2:
        return 'Bueno';
      case 3:
        return 'Regular';
      case 4:
        return 'Necesita Mejorar';
      default:
        return '';
    }
  };

  infoArray.forEach((element: any) => {
    const { nombreOperario, tipo, calificacionID } = element;

    if (!operariosMap[nombreOperario]) {
      operariosMap[nombreOperario] = {
        nombreOperario,
        fiscalizacion: [{
          imagen: '',
          rutinas: '',
          procedimiento: ''
        }]
      };
    }

    const calificacionObj = operariosMap[nombreOperario].fiscalizacion![0];
    const nuevaCalificacion = calificacionValor(calificacionID);

    switch (tipo) {
      case 'Imagen':
        calificacionObj.imagen = nuevaCalificacion;
        break;
      case 'Rutina':
        calificacionObj.rutinas = nuevaCalificacion;
        break;
      case 'Procedimiento':
        calificacionObj.procedimiento = nuevaCalificacion;
        break;
      default:
        break;
    }
  });

  const operario = Object.values(operariosMap);

  operario.forEach((element) => {
    element.fiscalizacion = element.fiscalizacion!.filter((fiscalizacion) => {
      return (
        fiscalizacion.imagen !== '' ||
        fiscalizacion.rutinas !== '' ||
        fiscalizacion.procedimiento !== ''
      );
    });
  });

  return {
    name,
    img,
    operario: info
}

}


function fiscalizacionDepositoResumen(name: string, img: string, calificacion_id?: any): IResumenDeposito {
  const calificationArray = Array.isArray(calificacion_id) ? calificacion_id : [calificacion_id];

  const calificacionValor = (calificacion_id: number) => {
    switch (calificacion_id) {
      case 1:
        return 'Excelente';
      case 8:
        return 'Muy bueno';
      case 2:
        return 'Bueno';
      case 3:
        return 'Regular';
      case 4:
        return 'Deficiente';
      case 7:
        return 'Deficiente';
      default:
        return '';
    }
  };

  let calificacion = '';
  calificationArray.forEach((element: any) => {
    calificacion = element?.calificacion || calificacionValor(element?.calificacion_id);
  });

  return {
    name,
    img,
    calificacion_id: calificacion,
  };
}


function fiscalizacionMaquinasResumen(name:string, img:string, info?: any) {
  const infoArray = Array.isArray(info) ? info[0] : [info[0]];
  const calificacionValor = (calificacion_id: number) => {
    switch (calificacion_id) {
      case 5:
        return 'Limpio';
      case 6:
        return 'Sucio';
      case 7:
        return 'Descompuesto';
      default:
        return '';
    }
  };

  const calificacionActual = infoArray?.map((element) => {
    return calificacionValor(element.calificacion_id);
  });

  const updateInfo = infoArray?.map((element, index) => {

    return {
      ...element,
      calificacion_id: calificacionActual[index]
    };
  });

  return {
    name,
    img,
    info: updateInfo
  };
}

function fiscalizacionLPResumen(name: string, img: string, info:any) {
  const infoArray = Array.isArray(info) ? info : [info];
  return {
    name,
    img,
    info: infoArray.filter(Boolean),
  };
}


function fiscalizacionOpinionResumen(name:string, img:string, info?:any) {
  const infoArray = Array.isArray(info) ? info : [info];
  return {
    name,
    img,
    info: infoArray
  };
}

function fiscalizacionStockResumen(name:string, img:string, info?:any) {
  const infoArray = Array.isArray(info) ? info[0] : [info[0]];
  return {
    name,
    img,
    info: infoArray
  };
}

function Row(props, index) {
  const { row } = props;
  console.log('============>', row);
  const [open, setOpen] = React.useState(false);
  const [openOperario, setOpenOperario] = React.useState({});

  const classes = useRowStyles();

  const handleOperarioClick = (nombre) => {
    setOpenOperario((prev) => ({
      ...prev,
      [nombre]: !prev[nombre],
    }));
  };

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <Avatar alt={row.name} src={row.img} />
        </TableCell>
        <TableCell>
          <IconButton aria-label="expand row" size="medium" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" key={row[index]}>
          {row.name}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit className="collapsibleContainer">
            <Box margin={1} padding={0} borderBottom={0} className="collapsibleContent">
              <Typography variant="subtitle2" gutterBottom component="div">
                Fiscalización {row.name}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      {row.name === 'Personal'
                        ? 'Operario'
                        : row.name === 'Depósito'
                        ? 'Deposito'
                        : row.name === 'Máquinas'
                        ? 'Máquinas'
                        : row.name === 'Limpieza General'
                        ? 'Limpieza General'
                        : row.name === 'Opinion del Cliente'
                        ? 'Opinion del Cliente'
                        : row.name === 'STOCK'
                        ? 'Stock'
                        : ''}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.name === 'Personal' && row.operario?.map((operarioRow) => (
                    <React.Fragment key={operarioRow.nombreOperario}>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          {operarioRow.nombreOperario}
                        </TableCell>
                        <TableCell>
                          <IconButton aria-label="row" size="small" onClick={() => handleOperarioClick(operarioRow.nombreOperario)}>
                            {openOperario[operarioRow.nombreOperario] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                          <Collapse in={openOperario[operarioRow.nombreOperario]} timeout="auto" unmountOnExit>
                            <Box margin={0} padding={0} borderBottom={0} className="collapsibleContent">
                              <Table size="small" aria-label="purchases">
                                <TableBody>
                                  {operarioRow.fiscalizacion.map((fiscalizacionRow, index) => (
                                    <React.Fragment key={index}>
                                      <TableRow>
                                        <TableCell>
                                          <Typography variant="caption">Imagen:</Typography>
                                        </TableCell>
                                        <TableCell>{fiscalizacionRow?.imagen}</TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell>
                                          <Typography variant="caption">Rutina:</Typography>
                                        </TableCell>
                                        <TableCell>{fiscalizacionRow?.rutinas}</TableCell>
                                      </TableRow>
                                      <TableRow>
                                        <TableCell>
                                          <Typography variant="caption">Procedimiento:</Typography>
                                        </TableCell>
                                        <TableCell>{fiscalizacionRow?.procedimiento}</TableCell>
                                      </TableRow>
                                    </React.Fragment>
                                  ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                  {row.name === 'Depósito' && (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {row.calificacion_id}
                      </TableCell>
                    </TableRow>
                  )}
                  {row.name === 'Limpieza General' && (
    (Array.isArray(row.info) ? row.info : []).map((infoRow) => (
      <React.Fragment key={infoRow.id}>
        <TableRow>
          <TableCell variant='head'><h6>{infoRow.calificacion || '-'}</h6></TableCell>
          <TableCell></TableCell>
        </TableRow>
        <TableRow style={{display:'flex', fontSize: 16}} component='td' scope='row'>
          <TableCell>{`Comentario: ${infoRow.comentario || '-'}`}</TableCell>
        </TableRow>
        {infoRow.acciones_correctivas && (
          <TableRow style={{display:'flex', fontSize: 16}} component='td' scope='row'>
            <TableCell>{`Acciones Correctivas: ${infoRow.acciones_correctivas}`}</TableCell>
          </TableRow>
        )}
      </React.Fragment>
    ))
  )}
  {row.name === 'Máquinas' && (
    (Array.isArray(row.info) ? row.info : []).map((infoMachine) => (
      <TableRow key={infoMachine.maquina_descripcion}>
        <TableCell>
          maquina: {infoMachine.maquina_descripcion}
        </TableCell>
        <TableCell component="th" scope="row">
          condición: {infoMachine.calificacion_id}
        </TableCell>
      </TableRow>
    ))
  )}
  {row.name === 'Opinion del Cliente' && (
    (Array.isArray(row.info) ? row.info : []).map((infoOpinion) => (
      <TableRow key={infoOpinion.contacto}>
        <TableCell>
          contacto: {infoOpinion.contacto}
        </TableCell>
        <TableCell component="th" scope="row">
          comentario: {infoOpinion.comentario}
        </TableCell>
      </TableRow>
    ))
  )}
  {row.name === 'STOCK' && (
    (Array.isArray(row.info) ? row.info : []).map((infoStock) => (
      <TableRow key={infoStock.DescripcionItem}>
        <TableCell>
          Producto: {infoStock.DescripcionItem}
        </TableCell>
        <TableCell component="th" scope="row">
          stock actual: {infoStock.CantidadStock}
        </TableCell>
        <TableCell component="th" scope="row">
          porcentaje actual: {infoStock.porcentaje}
        </TableCell>
      </TableRow>
    ))
  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const ResumenFiscalizacionComponent: React.FC = () => {
  const { ps_id, nombre, codigo, fis_id, objetivo } = useParams<Params>();

  const fiscalizacionContext = useContext(FiscalizacionContext);

  if (!fiscalizacionContext) {
    throw new Error('useFiscalizacion must be used within a FiscalizacionProvider');
  }

  const { informacionFiscalizacion, fiscalizacionDeposito, fiscalizacionLP, fiscalizacionMaquinas, fiscalizacionStock, fiscalizacionOpinion } = fiscalizacionContext;


  const rows = [
    fiscalizacionPersonal('Personal', 'assets/icon/fisc-COD1.svg', informacionFiscalizacion),
    fiscalizacionDepositoResumen('Depósito', `assets/icon/fisc-COD2.svg`, fiscalizacionDeposito),
    fiscalizacionMaquinasResumen('Máquinas', `assets/icon/fisc-COD3.svg`, fiscalizacionMaquinas),
    fiscalizacionLPResumen('Limpieza General', `assets/icon/fisc-COD4.svg`, fiscalizacionLP),
    fiscalizacionOpinionResumen('Opinion del Cliente', `assets/icon/fisc-COD5.svg`, fiscalizacionOpinion ),
    fiscalizacionStockResumen('STOCK', `assets/icon/fisc-COD6.svg`, fiscalizacionStock ),
  ];
  console.log(rows);
  return (
    <IonPage>
      <Header titulo="Fiscalización - Resumen" />

      <IonContent id="fiscalizacion">
        <div className="fisContainer">
          <PanelFiscalizacion />
          <IonItem>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead style={{ display: 'inline-flex' }}>
                  <img style={{ width: 40 }} src="assets/icon/fisc-COD5.svg" alt="Opinion del Cliente" />
                  <h1>RESUMEN</h1>
                </TableHead>
                <TableBody style={{ display: 'table', width: '100%' }}>
                  {rows.map((row) => (
                    <Row key={row.name} row={row} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </IonItem>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ResumenFiscalizacionComponent;

